import React from 'react';
import classnames from 'classnames';
import * as styles from './base.scss';
function href(name) {
    return `/styles/images/icons.svg#icon-${name}`;
}
const translateMap = {
    'arrow-up': {
        name: 'arrow-right',
        appearance: 'rotate270',
    },
    'arrow-down': {
        name: 'arrow-right',
        appearance: 'rotate90',
    },
    'arrow-left': {
        name: 'arrow-right',
        appearance: 'rotate180',
    },
};
const flipIcons = {
    user: {
        appearance: 'flip',
    },
    question: {
        appearance: 'flip',
    },
    exclamation: {
        appearance: 'flip',
    },
    archive: {
        appearance: 'flip',
    },
    calendar: {
        appearance: 'flip',
    },
    krav: {
        appearance: 'large',
    },
    carrot: {
        appearance: 'large',
    },
    milk: {
        appearance: 'large-v',
    },
    glutenfree: {
        appearance: 'large',
    },
    keyhole: {
        appearance: 'large-h',
    },
    eko: {
        appearance: 'large',
    },
    fair: {
        appearance: 'extra-large',
    },
    missing: {
        appearance: 'large',
    },
};
const Icon = ({ name, appearance, className, onClick }) => {
    const appearances = (typeof appearance === 'string' ? [appearance] : appearance || []);
    if (name in translateMap) {
        const translated = translateMap[name];
        name = translated.name;
        appearances.push(translated.appearance);
    }
    if (name in flipIcons) {
        const flipped = flipIcons[name];
        appearances.push(flipped.appearance);
    }
    return (React.createElement("svg", { className: classnames(styles.base, className, appearances.map(appearance => styles[appearance])), onClick: onClick },
        React.createElement("use", { href: href(name) })));
};
export default Icon;
